import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@/components/atoms';

const MediaPreviewModal = ({
  showModal,
  onClose,
  mediaUrl,
  mediaType,
  title
}) => {
  if (!showModal) return null;

  return (
    <Modal
      type='S'
      showModal={showModal}
      isDark={true}
      title={
        title || (mediaType === 'video' ? 'Video Preview' : 'Image Preview')
      }
      onCloseModal={onClose}
      onClickPrimaryButton={onClose}
      onClickSecondaryButton={onClose}
      primaryButtonText='Close'
      showPrimaryButton={true}
      showSecondaryButton={false}
      classNameWrapper='flex items-center justify-center'
      content={
        <div className='flex w-full items-center justify-center p-4'>
          {mediaType === 'video' ? (
            <video
              src={mediaUrl}
              controls
              autoPlay
              className='max-h-[60vh] w-full rounded-lg object-contain'
              data-testid='media-preview-video'>
              <track kind='captions' />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={mediaUrl}
              alt={title || 'Preview'}
              className='max-h-[60vh] w-full rounded-lg object-contain'
              data-testid='media-preview-image'
            />
          )}
        </div>
      }
    />
  );
};

MediaPreviewModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mediaUrl: PropTypes.string.isRequired,
  mediaType: PropTypes.oneOf(['image', 'video']).isRequired,
  title: PropTypes.string
};

export default React.memo(MediaPreviewModal);
